import { createGenericReducer } from "common/genericReducer";
import { RequestState } from "common/RequestState";
import { combineReducers } from "redux";
import {
  CHANGE_EMAIL_RECEIVED,
  CHANGE_EMAIL_REQUESTED,
  CHANGE_EMAIL_REQUEST_FAILED,
  CHANGE_EMAIL_REQUEST_RESET,
  CONFIRM_CHANGE_EMAIL_RECEIVED,
  CONFIRM_CHANGE_EMAIL_REQUESTED,
  CONFIRM_CHANGE_EMAIL_REQUEST_FAILED
} from "./changeEmailActions";

const createConfirmEmailReducer = () => {
  return createGenericReducer(
    CONFIRM_CHANGE_EMAIL_REQUESTED,
    CONFIRM_CHANGE_EMAIL_RECEIVED,
    CONFIRM_CHANGE_EMAIL_REQUEST_FAILED
  );
};

export const createRequestChangeEmailReducer = () => {
  const customReducer = (state, action) => {
    switch (action.type) {
      case CHANGE_EMAIL_REQUEST_FAILED:
        return {
          ...state,
          requestState: RequestState.Failed,
          correlationId: action.correlationId,
          isEmailInUseError: !!action.emailInUse
        };
      default:
        return state;
    }
  };
  return createGenericReducer(
    CHANGE_EMAIL_REQUESTED,
    CHANGE_EMAIL_RECEIVED,
    null,
    CHANGE_EMAIL_REQUEST_RESET,
    customReducer
  );
};

export const changeEmail = combineReducers({
  changeEmailRequest: createRequestChangeEmailReducer(),
  changeEmailConfirmation: createConfirmEmailReducer()
});
